export default "__VITE_ASSET__xHswNAza__"